module.exports = __webpack_public_path__ + "static/media/PhoAlphabet4-15.84d02f34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/PhoAlphabet4-15.svg
// module id = 761
// module chunks = 0